// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Dj-qs","footer__item":"Footer_footer__item__ze1XX"};